import ProdottiPageComponent from "./components/ProdottiPageComponent";
import { useSelector } from "react-redux";
import axios from "axios";

const getBestsellers = async () => {
    const { data } = await axios.get("/api/products/bestsellers");
    return data;
}

const ProdottiPage = () => {

    const { categories } = useSelector((state) => state.getCategories);

  return <ProdottiPageComponent categories={categories} getBestsellers={getBestsellers} />;
};

export default ProdottiPage;
